module.exports = __webpack_public_path__ + "static/img/mobile_home_tzjsmfw_scdy.c3e60e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_tzjsmfw_scdy.png
// module id = J3/I
// module chunks = 21